module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var date_time_1 = __webpack_require__(6);
var number_helpers_1 = __webpack_require__(7);
var Currencies = {
    eur: '€',
    rur: '₽',
    usd: '$',
};
function buildPriceHistory(events) {
    return events.map(function (event, index, array) {
        if (index === 0) {
            return getStartPriceString(event);
        }
        var prevEvent = array[index - 1];
        if (prevEvent.priceData.currency !== event.priceData.currency) {
            return getOtherCurrencyString(event);
        }
        return getPriceDiffString(array[index - 1], event);
    });
}
exports.buildPriceHistory = buildPriceHistory;
function getCurrencySign(currency) {
    return currency ? Currencies[currency] : '';
}
exports.getCurrencySign = getCurrencySign;
function getStartPriceString(startPriceEvent) {
    var _a = startPriceEvent.priceData, price = _a.price, currency = _a.currency, paymentPeriod = _a.paymentPeriod, changeTime = startPriceEvent.changeTime;
    return {
        currency: currency,
        date: date_time_1.getFormattedDate(new Date(changeTime)),
        diff: '',
        newPrice: number_helpers_1.numberToPrettyString(price),
        paymentPeriod: paymentPeriod,
        sign: '',
        trend: 'none',
    };
}
exports.getStartPriceString = getStartPriceString;
function getOtherCurrencyString(priceEvent) {
    var _a = priceEvent.priceData, price = _a.price, currency = _a.currency, paymentPeriod = _a.paymentPeriod, changeTime = priceEvent.changeTime;
    return {
        currency: currency,
        date: date_time_1.getFormattedDate(new Date(changeTime)),
        diff: 'Смена валюты',
        newPrice: number_helpers_1.numberToPrettyString(price),
        paymentPeriod: paymentPeriod,
        sign: '',
        trend: 'none',
    };
}
exports.getOtherCurrencyString = getOtherCurrencyString;
function getPriceDiffString(oldPriceEvent, newPriceEvent) {
    var oldPrice = oldPriceEvent.priceData.price;
    var newPrice = newPriceEvent.priceData.price;
    var _a = newPriceEvent.priceData, currency = _a.currency, paymentPeriod = _a.paymentPeriod;
    var priceDiff = newPrice - oldPrice;
    return {
        currency: currency,
        date: date_time_1.getFormattedDate(new Date(newPriceEvent.changeTime)),
        diff: "" + number_helpers_1.numberToPrettyString(Math.abs(priceDiff)),
        newPrice: number_helpers_1.numberToPrettyString(newPrice),
        paymentPeriod: paymentPeriod,
        sign: priceDiff > 0 ? '+' : '-',
        trend: priceDiff > 0 ? 'increase' : 'decrease',
    };
}
exports.getPriceDiffString = getPriceDiffString;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(4), exports);
var history_builder_1 = __webpack_require__(2);
exports.buildPriceHistory = history_builder_1.buildPriceHistory;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
var style_1 = __webpack_require__(5);
var history_builder_1 = __webpack_require__(2);
var icon_mail_1 = __webpack_require__(8);
var styles = __webpack_require__(9);
var PriceHistoryWidget = /** @class */ (function (_super) {
    tslib_1.__extends(PriceHistoryWidget, _super);
    function PriceHistoryWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            events: history_builder_1.buildPriceHistory(props.events.slice()),
        };
        return _this;
    }
    PriceHistoryWidget.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            events: history_builder_1.buildPriceHistory(nextProps.events.slice()),
        });
    };
    PriceHistoryWidget.prototype.render = function () {
        return (React.createElement("div", { className: styles['container'] },
            React.createElement("div", { className: styles['title'] }, this.props.title),
            React.createElement("div", { className: styles['divider'] }),
            React.createElement("div", { className: styles['history-wrapper'] },
                React.createElement("table", { className: styles['history'] },
                    React.createElement("tbody", null, this.state.events.reverse().map(function (event, index) {
                        return React.createElement("tr", { key: index, className: styles['history-event'] },
                            React.createElement("td", { className: styles['event-date'] }, event.date),
                            React.createElement("td", { className: styles['event-price'] }, event.newPrice + " " + history_builder_1.getCurrencySign(event.currency)),
                            React.createElement("td", tslib_1.__assign({}, style_1.mergeStyles(styles['event-diff'], event.trend === 'increase' && styles['event-diff-increase'], event.trend === 'decrease' && styles['event-diff-decrease'])),
                                event.sign ? event.sign + ' ' : '',
                                event.diff,
                                // Не выводим знак валюты, если меняется валюта или начальная цена (trend none)
                                event.trend !== 'none' ? ' ' + history_builder_1.getCurrencySign(event.currency) : ''));
                    })))),
            this.props.showSubscribeLink && this.renderSubscribeLink()));
    };
    PriceHistoryWidget.prototype.renderSubscribeLink = function () {
        return [
            React.createElement("div", { key: "divider", className: styles['divider'] }),
            React.createElement("div", { key: "subscribe", className: styles['subscribe-link'], onClick: this.props.onSubscribeLinkClick },
                React.createElement("span", null,
                    React.createElement(icon_mail_1.IconMail, null),
                    " \u0421\u043B\u0435\u0434\u0438\u0442\u044C \u0437\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435\u043C \u0446\u0435\u043D\u044B")),
        ];
    };
    return PriceHistoryWidget;
}(React.Component));
exports.PriceHistoryWidget = PriceHistoryWidget;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isStyleProps(styleArgument) {
    if (typeof styleArgument === 'object' && !Array.isArray(styleArgument)) {
        return styleArgument.hasOwnProperty('style') && styleArgument.hasOwnProperty('className');
    }
    return false;
}
var reduce = function (acc, style) {
    if (typeof style === 'string') {
        acc.className += acc.className.length === 0
            ? style
            : " " + style;
    }
    else if (typeof style === 'object') {
        if (isStyleProps(style)) {
            acc.className += acc.className.length === 0
                ? style.className
                : " " + style.className;
            Object.assign(acc.style, style.style);
        }
        else if (Array.isArray(style)) {
            return style.reduce(reduce, acc);
        }
        else {
            Object.assign(acc.style, style);
        }
    }
    return acc;
};
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return styles.reduce(reduce, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;
//# sourceMappingURL=style.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var monthNames = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];
function isValidDate(date) {
    return !isNaN(date.getTime());
}
exports.isValidDate = isValidDate;
function leftPadZero(value) {
    if (value < 10) {
        return "0" + value;
    }
    return value.toString();
}
exports.leftPadZero = leftPadZero;
function getTime(date) {
    return leftPadZero(date.getHours()) + ":" + leftPadZero(date.getMinutes());
}
exports.getTime = getTime;
function mapDayToString(date, now) {
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (now.getFullYear() !== date.getFullYear() || now.getMonth() !== date.getMonth()) {
        return undefined;
    }
    if (now.getDate() === date.getDate()) {
        return 'сегодня';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'вчера';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'позавчера';
    }
    return undefined;
}
exports.mapDayToString = mapDayToString;
function getFormattedDate(date, now) {
    var day = mapDayToString(date);
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (day) {
        return day + " " + getTime(date);
    }
    if (now.getFullYear() === date.getFullYear()) {
        return date.getDate() + " " + monthNames[date.getMonth()] + " " + getTime(date);
    }
    return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
}
exports.getFormattedDate = getFormattedDate;
//# sourceMappingURL=date_time.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NOT_NUMBER_REX = /[^0-9]/g;
var NUMBER_GROUP_REX = /.{1,3}/g;
function parseNumber(s) {
    var sign = s[0] === '-' ? '-' : '';
    var _a = s.split('.'), integer = _a[0], fractional = _a[1];
    return {
        fractional: fractional ? fractional.replace(NOT_NUMBER_REX, '') : '',
        integer: integer.replace(NOT_NUMBER_REX, ''),
        sign: sign,
    };
}
exports.parseNumber = parseNumber;
function numberToPrettyString(defaultNumber, separator) {
    if (separator === void 0) { separator = ','; }
    var _a = parseNumber(String(defaultNumber)), fractional = _a.fractional, integer = _a.integer, sign = _a.sign;
    var parsedInteger = reverseString(integer).match(NUMBER_GROUP_REX) || [];
    var prettyInteger = parsedInteger.reverse().map(reverseString).join(' ');
    return !fractional ? "" + sign + prettyInteger : "" + sign + prettyInteger + separator + fractional;
}
exports.numberToPrettyString = numberToPrettyString;
function reverseString(s) {
    return s.split('').reverse().join('');
}
//# sourceMappingURL=number_helpers.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
exports.IconMail = function () { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 10" },
    React.createElement("path", { fill: "currentColor", d: "M.91 0h14.15c.092 0 .182 0 .273.027L8 5.137.667.027C.757 0 .847 0 .91 0zM16 9.176c0 .467-.394.824-.91.824H.91C.393 10 0 9.643 0 9.176V.934L8 6.51l8-5.55v8.216z" }))); };


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"price_history_widget-container-gsYeZFPFUOg","title":"price_history_widget-title-aDJ8gNX3rM4","divider":"price_history_widget-divider-WzfXYyrW0g","history":"price_history_widget-history-bUNOGcKgUw0","history-wrapper":"price_history_widget-history-wrapper-himtM3CMN2Y","history-event":"price_history_widget-history-event-3YSmJGsQmQK","event-date":"price_history_widget-event-date-hOroRGOmtMy","event-price":"price_history_widget-event-price-fIaG9ItQcgK","event-diff":"price_history_widget-event-diff-7qOCyFrSBGK","event-diff-increase":"price_history_widget-event-diff-increase-2t4SZ5XTfG0","event-diff-decrease":"price_history_widget-event-diff-decrease-jcvnzi8EjCw","subscribe-link":"price_history_widget-subscribe-link-eToBJVQrM4q"};

/***/ })
/******/ ]);
//# sourceMappingURL=frontend-price-history-widget.js.map